/**
 * Creado por Norte70
 *
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 23/10/2020
 */
import * as SessionUtils from './../../../core/session_utils.js'

const processesListRequest = () => {
    return {
        public: 1,
        type_of_person: 'ambas',
        category:'ciudadano',
        category_id: 1,
        invited: SessionUtils.isGuestUser(),
    }
}

export default processesListRequest;